/* ============
 * Organizations Mutations
 * ============
 *
 * The mutations available for the organizations module.
 */

import {
  ALL,
  SET_CURRENT_PAGE,
  SET_ALL,
  SET_ACTIVE_DOMAIN,
  RESET_ACTIVE_DOMAIN,
} from './mutation-types';

export default {
  /**
   * Mutation to update the store with the fetched organizations.
   *
   * @param {Object} state      The current state of the store.
   * @param {Array}  organizations     The fetched organizations.
   * @param {Object} pagination The fetched pagination.
   */
  [ALL](state, { organizations, pagination }) {
    state.all = organizations;
    if (pagination !== undefined) {
      Object.keys(pagination)
        .forEach((key) => {
          state.pagination[key] = pagination[key];
        });
    }
  },
  [SET_ALL](state, organizations) {
    state.all = organizations;
  },
  [SET_CURRENT_PAGE](state, currentPage) {
    state.pagination.currentPage = currentPage;
  },
  [SET_ACTIVE_DOMAIN](state, domain) {
    state.activeDomain = domain;
  },
  [RESET_ACTIVE_DOMAIN](state) {
    state.activeDomain = undefined;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/organizations/mutations.js